import { StyleSheet } from 'react-native';
import Theme from 'Theme/index';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const baseStyles = {
    ...dialogCommon,
    buttonContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column-reverse'
    },
    button: {
        margin: Theme.BU / 2,
        width: '100%'
    },
    titleContainer: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    title: {
        ...dialogCommon.title,
        marginTop: dialogCommon.title.marginBottom,
        marginLeft: 8
    },
    line: {
        marginBottom: Theme.primaryMargin
    },
    descriptionBlock: {
        maxHeight: '30%'
    },
    bellIcon: {
        marginBottom: Theme.BU
    },
    closeIconContainer: {
        position: 'absolute',
        top: 5,
        right: 5,
        left: 0,
        bottom: 0
    },
    alarmIconContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

const landscapeStyles = StyleSheet.create({
    ...baseStyles,
    window: {
        ...baseStyles.window,
        paddingHorizontal: '20%'
    },
    buttonContainer: {
        ...baseStyles.buttonContainer,
        flexDirection: 'row'
    },
    button: {
        ...baseStyles.button,
        width: '40%',
        maxWidth: '40%'
    },
    descriptionBlock: {
        maxHeight: '50%'
    }
});

if (Device.isTabletOrWeb) {
    baseStyles.buttonContainer.flexDirection = 'row';
    delete baseStyles.button.width;
}

export { landscapeStyles };
export default StyleSheet.create(baseStyles);
